import AllocationManager from './AllocationManager.jsx';

export default AllocationManager;
